import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ReferralLeadsRoutingModule} from './referral-leads-routing.module';
import {ReferralLeadsComponent} from './referral-leads.component';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';


@NgModule({
    declarations: [ReferralLeadsComponent],
    imports: [
        CommonModule,
        ReferralLeadsRoutingModule,
        NgbModule,
        CoreDirectivesModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ]
})
export class ReferralLeadsModule {
}
